// Lib
import { isString } from 'lodash/fp';

// Utils
import { propIn } from '../../../../common/utils/immutableHelper';
import { getMediaType } from '../../../../common/elements/utils/elementPropertyUtils';
import { detectProviderFromUrl } from '../../../../common/links/detectProviderFromUrl';

// Types
import { ImMNElement } from '../../../../common/elements/elementModelTypes';

// Constants
import { Providers } from '../../../../common/links/linkConstants';
import { MEDIA_TYPES } from '../../../../common/links/richMediaConstants';
import { PlatformType } from '../../../../common/platform/platformTypes';

// Providers that won't be auto-embedded
const AUTO_EMBED_BLACKLIST: { [key in Providers]?: boolean } = {
    [Providers.YouTube]: true,
    [Providers.Vimeo]: true,
    [Providers.SoundCloud]: true,
    [Providers.Loom]: true,
    [Providers.Wistia]: true,
};

export const platformAllowsIFrameEmbeds = (platformType?: PlatformType): boolean => {
    // WEB-13106 - Don't render iframes on iPhones to avoid forced composite layers
    if (platformType === PlatformType.iphone) {
        return false;
    }

    return true;
};

/**
 * Determines if a link element should be auto-embedded
 */
export default function shouldAutoEmbed(element: ImMNElement, platformType?: PlatformType): boolean {
    if (!platformAllowsIFrameEmbeds(platformType)) {
        return false;
    }

    let providerName = propIn(['content', 'provider', 'name'], element);

    if (!providerName) {
        const url = propIn(['content', 'link', 'url'], element);
        if (url && isString(url)) {
            providerName = detectProviderFromUrl(url);
        }
    }

    const isBlacklisted = AUTO_EMBED_BLACKLIST[providerName as Providers] || false;
    const isVideo = getMediaType(element) === MEDIA_TYPES.VIDEO;

    return !isBlacklisted && !isVideo;
}
